import React, { Component } from 'react'
import { Header, List } from './summary.style'
import { DARKGREEN, RED, DARKGRAY } from '../../../../styles/colors.style'

class Summary extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		const { invoices } = this.props
		const zeroValue = 0
		return (
			<div>
				<Header>
					<h2>Resumo das faturas</h2>
				</Header>
				<List>
					{invoices.length > 0
						? invoices.map(
							({ monthDescription, partialValue, status }, index) => {
								let color = DARKGRAY;
								color = status === "Paga" ? DARKGREEN : status === "Vencida" ? RED : color;
								return (
									<li key={index}>
										<p className="orange">
											{monthDescription.substr(0, 3)}
										</p>
										<p style={{ color: color }}>
											{partialValue && partialValue > 0
												? partialValue.$toReais()
												: zeroValue.$toReais()}
										</p>
									</li>
								)
							}
						)
						: null}
				</List>
			</div>
		)
	}
}

export default Summary
